

export const countryMap = {
    us: 'usa',
    ca: 'can',
    canada: 'can'
};